module.exports = __webpack_public_path__ + "img/2019-04-29.f7e8ff61.jpg";